export default {
      id: "business_center-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#business_center",
      toString: function () {
        return this.url;
      }
    }